// src/redux/job/jobAction.js

import axios from "axios";
import {
  JOB_ADD,
  JOB_UPDATE,
  JOB_DELETE,
  JOB_LIST,
  JOB_GET_BY_ID,
  JOB_LOADING,
  JOB_ERROR,
} from "./jobConstants";
import { environmentalURL } from "../environmentalURL";



// Create Job
export const addJob = (formData) => async (dispatch) => {
  dispatch({ type: JOB_LOADING });
  try {
    const res = await axios.post(`${environmentalURL}/api/jobs/save`, formData);
    dispatch({ type: JOB_ADD, payload: res.data });
  } catch (err) {
    dispatch({ type: JOB_ERROR, payload: err });
  }
};

// Get All Jobs
export const listJobs = () => async (dispatch) => {
  dispatch({ type: JOB_LOADING });
  try {
    const res = await axios.get(`${environmentalURL}/api/`);
    dispatch({ type: JOB_LIST, payload: res.data });
  } catch (err) {
    dispatch({ type: JOB_ERROR, payload: err });
  }
};

// Get Job by ID
export const getJobById = (id) => async (dispatch) => {
  dispatch({ type: JOB_LOADING });
  try {
    const res = await axios.get(`${environmentalURL}/api/jobs/${id}`);
    dispatch({ type: JOB_GET_BY_ID, payload: res.data });
  } catch (err) {
    dispatch({ type: JOB_ERROR, payload: err });
  }
};

// Update Job
export const updateJob = (id, formData) => async (dispatch) => {
  dispatch({ type: JOB_LOADING });
  try {
    const res = await axios.put(`${environmentalURL}/api/jobs/update/${id}`, formData);
    dispatch({ type: JOB_UPDATE, payload: res.data });
  } catch (err) {
    dispatch({ type: JOB_ERROR, payload: err });
  }
};

// Delete Job
export const deleteJob = (id) => async (dispatch) => {
  dispatch({ type: JOB_LOADING });
  try {
    await axios.delete(`${environmentalURL}/api/jobs/delete/${id}`);
    dispatch({ type: JOB_DELETE, payload: id });
  } catch (err) {
    dispatch({ type: JOB_ERROR, payload: err });
  }
};
